exports.components = {
  "component---src-pages-bsalecode-js": () => import("./../../../src/pages/bsalecode.js" /* webpackChunkName: "component---src-pages-bsalecode-js" */),
  "component---src-pages-chose-template-js": () => import("./../../../src/pages/chose-template.js" /* webpackChunkName: "component---src-pages-chose-template-js" */),
  "component---src-pages-code-js": () => import("./../../../src/pages/code.js" /* webpackChunkName: "component---src-pages-code-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-workflowedit-js": () => import("./../../../src/pages/workflowedit.js" /* webpackChunkName: "component---src-pages-workflowedit-js" */)
}

